module.exports = __webpack_public_path__ + "media/components/country-flag/static/ua-7f06c8f28d1bbfd54696a920a76795a4.svg";